import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { filter, Observable, of, throwError } from 'rxjs';
import { MdrDashboardsService } from '../../mdr-dashboards/services/mdr-dashboards.service';
import { OrganizationsService } from '../../organizations/services/organizations.service';
import { catchError, map } from 'rxjs/operators';
import { IdentityService } from '../services/identity.service';

@Injectable({
    providedIn: 'root',
})
class LcoGuardService {
    constructor(
        private mdrService: MdrDashboardsService,
        private identityService: IdentityService,
        private organizationService: OrganizationsService,
        private router: Router,
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        if (this.identityService.companyLoaded) {
            return of(this.redirectToProperUrl());
        }

        return this.identityService.companyLoaded$.pipe(
            filter((isLoaded) => isLoaded),
            catchError((err, obs: any) => {
                return throwError(() => err);
            }),
            map(() => {
                return this.redirectToProperUrl();
            }),
        );
    }

    public redirectToProperUrl() {
        const organization = this.organizationService.currentlySelectedOrganization() || this.identityService.company;

        /** If the company is LCO it s not allowed to see this route */
        if (this.mdrService.isPremiumEnterprise(organization)) {
            return true;
        } else {
            this.router.navigate(['/dashboard/browse']).catch(console.error);
        }

        return false;
    }
}

export const LcoGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
    return inject(LcoGuardService).canActivate(next, state);
};
